
import { MetadataFieldDTO } from "./metadataFieldDTO";
import { TransformationRuleDTO } from "./transformationRuleDTO";

export class MetadataInfoDTO{
    public name!: string;
    public ruleId!: number;
    public fields!: MetadataFieldDTO[];
    public transformationRules!: TransformationRuleDTO[];
}